import React from "react";
import Chart from "react-apexcharts";
import { ClassificationDistributionType } from "../../../types/TeacherEvaluation";

const ClassificationDistributionChart = ({
  data,
}: {
  data: ClassificationDistributionType[];
}) => {
  const chartData = {
    series: [
      {
        name: "Quantidade",
        data: data.map((item) => item.count),
      },
    ],
    options: {
      chart: { type: "bar" as const }, // Especifica explicitamente o tipo como "bar"
      xaxis: { categories: data.map((item) => item.classification.toString()) },
      title: { text: "Distribuição de Classificações" },
    },
  };

  return <Chart options={chartData.options} series={chartData.series} type="bar" height={350} />;
};

export default ClassificationDistributionChart;
